import React from "react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

export function ChecklistTabs({ tabs, items, state, activeTab, onTabChange }) {
  return (
    <div className="flex border-b border-[#DCD4C6] mb-4">
      {tabs.map((tab) => {
        const tAll = [...(items[tab.id] || []), ...(state.custom[tab.id] || [])];
        const tDone = tAll.filter((i) => state.checked[tab.id]?.[i.id]).length;
        const tFull = tAll.length > 0 && tDone === tAll.length;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 py-3 text-xs font-medium transition-all flex items-center justify-center gap-1.5 ${
              activeTab === tab.id
                ? "text-[#C17F59] border-b-2 border-[#C17F59] -mb-px"
                : "text-[#9A8F86] hover:text-[#5C554E]"
            }`}
            style={LORA}
            data-testid={`tab-${tab.id}`}
          >
            <span className="hidden sm:inline">{tab.label}</span>
            <span className="sm:hidden">{tab.shortLabel}</span>
            {tFull && (
              <span
                className="inline-block w-1.5 h-1.5 bg-emerald-500 rounded-full flex-shrink-0"
                data-testid={`tab-done-dot-${tab.id}`}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
